<template>
  <div v-if="news" id="news-spot">
    <div
      @click="toPage(item.primary.url[0].text)"
      class="news-spot"
      v-for="(item, index) in news"
      :key="`${language}-${index}`"
    >
      <b-image
        class="img-news-spot"
        ratio="280by140"
        :src="item.primary.img.url"
      />
      <p :class="`mist-${language}-p has-text-left`">
        {{ item.primary.title[0].text }}
      </p>
    </div>
    <div class="btn-link" @click="toPage('/news')">
      <img :src="require(`@/assets/img/plus-icon.svg`)" />
      <span :class="`mist-${language}-link `">{{ label }}</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["news", "label"],
  data() {
    return {};
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
  },
  watch: {
    language() {
      // this.news = [];
      // this.getNews();
      // this.getTitle();
    },
  },
  mounted() {
    console.log(this.news);
    // this.getNews();
    // this.getTitle();
    // this.setAnimation();
    // $(document).scroll(this.setAnimation);
  },
  methods: {
    async getNews() {
      const me = this;
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["News","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      const data = res.data.results;
      data.forEach((arr) => {
        if (arr.type !== "news_header") {
          arr.data.body.forEach((item) => {
            me.news.push(item);
          });
        }
      });
      let sort = this.news.sort(function (a, b) {
        return new Date(b.primary.date) - new Date(a.primary.date);
      });
      sort = sort.slice(0, 3);
      this.news = sort;
    },
    async getTitle() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["NewsSpotlight","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      this.title = res.data.results[0].data.title[0].text;
      this.label = res.data.results[0].data.label[0].text;
    },
    toPage(url) {
      if (url.startsWith("http")) {
        let win = window.open(url, "_blank");
        win.focus();
      } else {
        this.$router.push("/News/" + url);
      }
    },
    setAnimation() {
      const height = $(window).scrollTop() + $(window).height();
      if ($(`#news-spot`).length > 0) {
        if (height > $(`#news-spot`).offset().top) {
          $(`#news-spot`)
            .addClass("animate__animated animate__fadeInUp")
            .removeClass("invisible");
        }
      }
    },
  },
};
</script>

<style scoped>
.img-news-spot {
  /* height: 140px; */
  margin: 34px 0 14px 0;
  width: 100%;
}
.btn-link {
  align-items: center;
  display: flex;
  margin-top: 27px;
  cursor: pointer;
}
.news-spot {
  cursor: pointer;
}
.news-spot:hover {
  color: #0053c6;
}
.btn-link:hover {
  color: #0053c6;
}
@media (max-width: 768px) {
  .img-news-spot {
    margin: 23px 0 10px 0;
  }
}
</style>